import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE; // 👈 CRA uses REACT_APP_

export const api = axios.create({
  baseURL: API_BASE,
});
